import React from "react";
import { OrderItem } from "@/api/models/api-types";
import { formatPrice } from "../utils/format-price";

interface OrderItemCardProps {
  item: OrderItem;
  currency: string;
}

export const OrderItemCard: React.FC<OrderItemCardProps> = ({
  item,
  currency,
}) => {
  // Get primary image
  const primaryImage =
    item.images?.find((img) => img.isPrimary) || item.images?.[0];
  // imageUrl is already a full URL from backend, no need to use getFileUrl
  const imageUrl = primaryImage?.imageUrl || null;

  return (
    <div className="flex gap-3 md:gap-4">
      {/* Product Image */}
      {imageUrl && (
        <div className="relative w-14 h-14 md:w-16 md:h-16 rounded-lg overflow-hidden flex-shrink-0">
          <img
            src={imageUrl}
            alt={item.name}
            className="w-full h-full object-cover"
          />
        </div>
      )}

      {/* Product Details */}
      <div className="flex-1 flex flex-col md:flex-row md:items-center md:justify-between gap-2 md:gap-0">
        <div className="flex flex-col gap-1 md:gap-2">
          {/* Product Name */}
          <h3 className="text-xs md:text-sm font-semibold text-text-primary dark:text-text-primary line-clamp-2">
            {item.name}
          </h3>

          {/* Product Attributes */}
          <div className="flex flex-wrap gap-2 md:gap-4 text-xs text-text-tertiary dark:text-text-tertiary">
            {item.axis1Name && item.a1Value && (
              <span>
                {item.axis1Name}: {item.a1Value}
              </span>
            )}
            {item.axis2Name && item.a2Value && (
              <span>
                {item.axis2Name}: {item.a2Value}
              </span>
            )}
            <span>Quantity: {item.quantity}</span>
          </div>
        </div>

        {/* Product Price */}
        <div className="text-sm font-semibold text-text-primary dark:text-text-primary md:ml-4">
          {formatPrice(item.amount, currency)}
        </div>
      </div>
    </div>
  );
};
